module.exports = __webpack_public_path__ + "static/media/Viking295_3c.84b8d601.svg";